import { EColors } from "common/styles"
import styled from "styled-components"

export const StyledListCertificates = styled.div`
display:flex;
flex-direction:column;
`
export const StyledCertificateItem = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
padding-top:24px;
padding-bottom:24px;
border-bottom:1px solid ${EColors.neutral_200};

`

export const IconArrowLink = styled.img`
width:24px;
height:24px;
margin-left:12px;
scale: 1;
transition: all 0.3s linear;
`
export const StyledSertificateLink = styled.button`
outline:none;
border:none;
background: transparent;
display: inline-flex;
align-items: center;
color:${EColors.primary_200};
text-decoration:none;
cursor: pointer;
&:hover  ${IconArrowLink}{
    scale:1.1;
}
`
export const ImageCertificate = styled.img`
width:48px;
height:48px;
margin-right:24px;
`
export const ImageCertificateBig = styled.img`
border-radius:12px;
width:100%;
height:100%;
z-index:16;
`

export const StyledSertificateTitle = styled.div`
display:flex;
align-items:center;
`
